document.addEventListener("DOMContentLoaded", function() {
  
  if (window.location.hostname === 'fr.holystrom.com' || window.location.hostname === 'de.holystrom.com' || window.location.hostname === 'nl.holystrom.com') {
    const styleTag = document.createElement('style')
    styleTag.textContent = '.transcy-switcher-manual { display: none !important; }'
    document.body.insertAdjacentElement('afterbegin', styleTag)
  }
  
  var elements = document.querySelectorAll('[data-show-correct-variant-id]');
  
  function updateDisplay(variantValue) {
    if (variantValue) {
      elements.forEach(function(element) {
        if (element.getAttribute('data-show-correct-variant-id') === variantValue) {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      });
    } else {
      elements.forEach(function(element) {
        element.style.display = 'none';
      });
    }
  }

  function startPollingForUrlChanges() {
    let lastVariant = getUrlParameter('variant');

    setInterval(function() {
      const currentVariant = getUrlParameter('variant');
      if (currentVariant !== lastVariant) {
        lastVariant = currentVariant;
        updateDisplay(currentVariant);  // Update when the variant changes
        console.log('Variant changed in URL:', currentVariant);
      }
    }, 500);  // Check the URL every 500ms (adjust this interval as needed)
  }
  
  function getUrlParameter(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    return results ? decodeURIComponent(results[1]) : null;
  }


  if (window.location.href.includes('/products')) {
    startPollingForUrlChanges();  // Start polling for URL changes
    if(getUrlParameter('variant')) {
      updateDisplay(getUrlParameter('variant'));
    }
  }
  
})
